function initializeSingleEmblaCarousel(emblaNode) {
  if (emblaNode.emblaApi) return;

  // Desktop uses a hover cross-fade instead of swipe, so pointer dragging is disabled there only.
  const options = {
    loop: false,
    breakpoints: {
      "(min-width: 991px)": { watchDrag: false },
    },
  };

  const emblaApi = EmblaCarousel(emblaNode, options);

  emblaNode.emblaApi = emblaApi;

  // Blocks the native image ghost-drag that's otherwise left enabled when Embla's drag handling is off.
  emblaNode.addEventListener("dragstart", (e) => e.preventDefault());

  const scrollbar = emblaNode.querySelector(".embla__scrollbar");
  const scrollbarThumb = emblaNode.querySelector(".embla__scrollbar-thumb");

  const stopProp = (e) => e.stopPropagation();
  ["touchstart", "touchmove", "touchend"].forEach((e) =>
    emblaNode.addEventListener(e, stopProp, { passive: true })
  );
  [
    "mousedown",
    "mousemove",
    "mouseup",
    "pointerdown",
    "pointermove",
    "pointerup",
  ].forEach((e) => emblaNode.addEventListener(e, stopProp));

  if (scrollbar && scrollbarThumb) {
    let inactivityTimer;

    const updateScrollbar = () => {
      const scrollProgress = emblaApi.scrollProgress();
      const slidesCount = emblaApi.slideNodes().length;

      if (slidesCount <= 1) {
        scrollbar.classList.add("hidden");
        return;
      }

      scrollbar.classList.remove("hidden");

      const thumbWidthPercent = (1 / slidesCount) * 100;

      const availableSpace = 100 - thumbWidthPercent;

      const thumbLeftPercent = scrollProgress * availableSpace;

      scrollbarThumb.style.setProperty(
        "--thumb-width",
        `${thumbWidthPercent}%`
      );
      scrollbarThumb.style.setProperty(
        "--thumb-left",
        `${thumbLeftPercent}%`
      );
    };

    const showScrollbar = () => {
      scrollbar.classList.remove("inactive");

      clearTimeout(inactivityTimer);

      inactivityTimer = setTimeout(() => {
        scrollbar.classList.add("inactive");
      }, 500);
    };

    emblaApi.on("scroll", () => {
      updateScrollbar();
      showScrollbar();
    });

    emblaApi.on("reInit", () => {
      updateScrollbar();
      showScrollbar();
    });

    emblaNode.addEventListener("touchstart", showScrollbar, {
      passive: true,
    });
    emblaNode.addEventListener("pointerdown", showScrollbar, {
      passive: true,
    });

    updateScrollbar();
    showScrollbar();
  }
}

let carouselObserver = null;

function getCarouselObserver() {
  if (!carouselObserver) {
    // rootMargin preloads ~200px early so the carousel is ready before it scrolls into view, avoiding a visible pop-in.
    carouselObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          initializeSingleEmblaCarousel(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: "200px 0px", threshold: 0 }
    );
  }
  return carouselObserver;
}

function observeProductCardCarousels() {
  if (typeof EmblaCarousel === "undefined") return;

  const emblaNodes = document.querySelectorAll(".product-card .embla");
  const observer = getCarouselObserver();

  emblaNodes.forEach((emblaNode) => {
    // Guards against double-observing, since initializeProductCards() is re-triggered by several other files (sort/filter, search, cart drawer).
    if (emblaNode.dataset.carouselObserved === "true") return;
    emblaNode.dataset.carouselObserved = "true";
    observer.observe(emblaNode);
  });
}

// Exposed so product-card-interactions.js's initializeProductCards() can re-scan for new carousels after any re-render.
window.observeProductCardCarousels = observeProductCardCarousels;
